import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Custom Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Manually design your own transport route by selecting points in a specific order. This allows you to apply domain expertise and create custom routing solutions based on your knowledge.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>Location points set up in Setup Mode</li>
            <li>Start point defined (automatically added as first point)</li>
            <li>Connections created in Connection Mode</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Build Route Sequence:</strong>
              <ul>
                <li>Start point is automatically added to the path</li>
                <li>Select next location from Available Points list or map</li>
                <li>Only connected points (with valid connections) are available</li>
                <li>Continue adding points to build your route</li>
              </ul>
            </li>
            <li><strong>View Path Information:</strong>
              <ul>
                <li><strong>Path Sequence:</strong> Shows points in order</li>
                <li><strong>Path Duration:</strong> Total travel time
                  <ul>
                    <li>Standard mode: Sum of connection durations</li>
                    <li>Capacity mode: Includes required trips calculation</li>
                  </ul>
                </li>
                <li><strong>Segment Details:</strong> (If capacity constraints enabled)
                  <ul>
                    <li>Each segment's transport mode</li>
                    <li>Single trip duration</li>
                    <li>Required trips based on demand/capacity</li>
                    <li>Total segment time</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Modify Path:</strong>
              <ul>
                <li>Click × button on a point to remove it from path</li>
                <li>Removed points return to Available Points list</li>
              </ul>
            </li>
            <li><strong>Confirm Path:</strong>
              <ul>
                <li>Click "Confirm Path" button to save</li>
                <li>Path will be stored for comparison</li>
              </ul>
            </li>
            <li><strong>Reset Path:</strong>
              <ul>
                <li>Click "Reset Path" to start over</li>
                <li>Returns to initial state with start point only</li>
              </ul>
            </li>
          </ol>

          <p><strong>Available Points Display:</strong></p>
          <ul>
            <li><strong>Connected Points:</strong> Show valid next destinations</li>
            <li><strong>Transport Mode:</strong> Shows available transport type</li>
            <li><strong>Duration:</strong> Shows segment travel time</li>
            <li><strong>Capacity Mode:</strong> Shows trips needed and total time</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>You can only select points that have connections from the last point</li>
            <li>Consider transport mode efficiency when selecting routes</li>
            <li>In capacity mode, multiple trips will affect total duration</li>
            <li>Compare your custom path with auto-generated solution in Comparison Mode</li>
            <li>Save your work by clicking Confirm Path before switching modes</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 